
  import InternationalTradeEconRev from '../InternationalTrade/InternationalTradeEconRev.vue';
  import InvestmentsWorldEconRev from '../investments/InvestmentsWorldEconRev.vue';
  import EconRevTemplate from './EconRevTemplate.vue';

  export default {
    name: 'WorldEconRev',
    components: {
      InternationalTradeEconRev,
      InvestmentsWorldEconRev,
      EconRevTemplate,
    },
    props: {
      countryId: {
        type: String,
        default: '',
      },
    },
    data(): {
      year: number;
    } {
      return {
        year: 2021,
      };
    },
  };
